import { t } from "i18next";
import "../../Style/finish/finish.css";
import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import OtpAckDialogWidget from "../../Widgets/otp-dialog/OtpAckDialogWidget";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Banner from '../../Assets/Images/Banner_Desktop_1920x412.jpg';
import { error } from "../../Components/custom-toast/CustomToast";
import { ackCallback } from "../../Services/api-service";

function AckSection() {
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const [data, setData] = useState();
    const navigation = useNavigate();
      const getQueryParam = (param) => {
        const queryParams = new URLSearchParams(location.search);
        return queryParams.get(param);
      };
      useEffect(() => {
        const queryData = getQueryParam("data");
        if (queryData) {
            setData(queryData);
            ackCallback(queryData, setIsLoading).then((data)=>{
                if(data === null) {
                    return error("Đã có lỗi xảy ra, vui lòng tải lại trang và thử lại");
                }
                setSuccess(data);
                return;
                }).catch((error)=>{
                setIsLoading(false);
                }).finally(()=>{
                setIsLoading(false);
                });
        }
      }, []);
    const [success, setSuccess] = useState(false);
    const handleClickSuccess = () => {
        window.scrollTo(0,0);
        navigation("/");
    }
    return (
        <section className="finish">
            <div className="finish-wrapper">
                <div className="finish-banner">
                    <img src={Banner} alt="Ack Banner" className="banner-img" />
                </div>
                {
                        isLoading ? 
                         <div className="circular-progress-main">
                                                <CircularProgress variant="indeterminate" className="progress-circle" size={100} thickness={4} />
                                            </div>
                                            :
                    success 
                    ? 
                    <div className="finish-content" style={{alignItems: "baseline"}}>
                        <h1 className="finish-h1" style={{fontWeight: "bold"}}>Chúc mừng bạn đã xác thực thành công<br/>
                        Hợp đồng bảo hiểm điện tử đã được gửi đến email của bạn.</h1>
                        <p className="finish-p">
                            Trân trọng !
                        </p>
                        <div className="finish-button">
                            <CustomButtonColor bgColor={"#c59812"} color={"#fff"} title={t("continue")} onClick={handleClickSuccess}/>
                        </div>
                    </div>
                    :
                    <OtpAckDialogWidget setIsLoading={setIsLoading} setSuccess={setSuccess} data={data}/>
                }
            </div>
        </section>
    );
}
export default AckSection;
